/** Mirrors server password policy in server/models/User.js */
export function validateRegistrationPassword(password: string): string | null {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  if (!/[@$!%*?&]/.test(password)) {
    errors.push('Password must contain at least one special character (@$!%*?&)');
  }

  return errors.length > 0 ? errors.join(', ') : null;
}

export function getApiErrorMessage(error: unknown, fallback = 'Request failed'): string {
  const apiError = error as {
    response?: { data?: { error?: string; message?: string } };
    message?: string;
  };

  return (
    apiError.response?.data?.error ||
    apiError.response?.data?.message ||
    (error instanceof Error ? error.message : undefined) ||
    fallback
  );
}
